import React, { Component } from 'react';
import debounce from 'lodash.debounce';
import PropTypes from 'prop-types';
import Quill from 'quill';

import 'components/input/RichTextInput.css'


export class RichTextInputWithImage extends Component {

  static propTypes = {
    addField: PropTypes.bool.isRequired,
    addLabel: PropTypes.bool.isRequired,
    input: PropTypes.object,
    label: PropTypes.string,
    options: PropTypes.object,
    source: PropTypes.string,
    toolbar: PropTypes.object,
    imageObj: PropTypes.object,
  };

  static defaultProps = {
    addField: true,
    addLabel: true,
    options: {},
    record: {},
  };

  componentDidMount() {
    const {
      input: {
        value,
      },
      toolbar,
    } = this.props;


    this.quill = new Quill(this.divRef, {
      modules: { toolbar },
      theme: 'snow',
    });

    this.quill.pasteHTML(value);

    this.editor = this.divRef.querySelector('.ql-editor');
    this.quill.on('text-change', debounce(this.onTextChange, 500));
  }

  componentWillUnmount() {
    this.quill.off('text-change', this.onTextChange);
    this.quill = null;
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.imageObj !== nextProps.imageObj) {
      this.insertToEditor('image', nextProps.imageObj.url)
    }
  }

  onTextChange = () => {
    this.props.input.onChange(this.editor.innerHTML);
  };

  updateDivRef = ref => {
    this.divRef = ref;
  };

  insertToEditor = (type, value) => {
    // push image url to rich editor.
    const range = this.quill.getSelection();
    if (range) {
      this.quill.insertEmbed(range.index, type, value);
      this.quill.setSelection(range.index + 1);
    }
  };

  render() {
    return <div className='aor-rich-text-input'>
      <div ref={this.updateDivRef}/>
    </div>
  }
}


// WEBPACK FOOTER //
// ./src/routes/news/components/RichTextInputWithImage.js